import api from '../lib/api';
import { toArray } from '../lib/utils';
import type { MessageQueue } from '../types/messageQueue';

class MessageQueueService {
  async getQueues(): Promise<MessageQueue[]> {
    const response = await api.get('/messages/queues');
    return toArray(response.data);
  }

  async getQueue(id: number): Promise<MessageQueue> {
    const response = await api.get(`/messages/queues/${id}`);
    return response.data;
  }

  async createQueue(data: Partial<MessageQueue>): Promise<MessageQueue> {
    const response = await api.post('/messages/queues', data);
    return response.data;
  }

  async updateQueue(id: number, data: Partial<MessageQueue>): Promise<MessageQueue> {
    const response = await api.put(`/messages/queues/${id}`, data);
    return response.data;
  }

  async deleteQueue(id: number): Promise<void> {
    await api.delete(`/messages/queues/${id}`);
  }

  async getIntegrations(): Promise<any[]> {
    const response = await api.get('/integrations');
    return Array.isArray(response.data) ? response.data : response.data?.data || [];
  }
}

export default new MessageQueueService();
